import { css } from 'styled-components';

import type { ITypography, TParagraphTypes } from '../types';

const colorTransition = 'color .3s ease';

const linkStyles = css`
  text-decoration: underline;
  text-decoration-thickness: 0.1rem;
  text-underline-offset: 2.5px;
  position: relative;

  &:hover {
    text-decoration-thickness: 0.2rem;
  }
`;

const darkLinkStyles = css`
  ${linkStyles}
  ${({ theme }) => `
    ${theme?.textLink?.dark?.text ? `color: ${theme?.textLink?.dark?.text};` : ''}
    ${theme?.textLink?.dark?.textHover ? `transition: ${colorTransition};` : ''}
  `}

  &:hover,
  &:focus {
    ${({ theme }) => `
      ${theme?.textLink?.dark?.textHover ? `color: ${theme?.textLink?.dark?.textHover};` : ''}
    `}
  }
`;

const lightLinkStyles = css`
  color: white;
  ${linkStyles}
  ${({ theme }) => `
    ${theme?.textLink?.light?.text ? `color: ${theme?.textLink?.light?.text};` : ''}
    ${theme?.textLink?.light?.textHover ? `transition: ${colorTransition};` : ''}
  `}

  &:hover,
  &:focus {
    ${({ theme }) => `
      ${theme?.textLink?.light?.textHover ? `color: ${theme?.textLink?.light?.textHover};` : ''}
    `}
  }
`;

const Paragraph = css<ITypography>`
  ${({ theme }) => theme.screenSize.s992.mediaQuery} {
    font-size: ${({ theme, variant }) => theme.typography.variants[variant as TParagraphTypes].desktopFontSize};
  }

  // Placed first to ensure it doesn't override other styles.
  p {
    margin: 0 0 1.6rem;

    &:last-child {
      margin: 0;
    }
  }

  h3 {
    ${({ theme }) => `
      ${theme.typography.variants.paragraph1.fontFace}
      font-size: ${theme.typography.variants.paragraph1.fontSize};
      font-weight: 500;  
      ${theme.screenSize.s768.mediaQuery} {
        font-size: ${theme.typography.variants.paragraph1.desktopFontSize};
      }
    `};
    margin: .8rem 0;
  }

  li {
    margin: 1.2rem 0 1.2rem 2rem;
  }

  ol,
  ul {
    padding: 0;
    margin-bottom: 1.6rem;
  }

  ol {
    li {
      margin-left: 2.2rem;
    }
  }

  ul {
    li {
      &::marker {
        color: ${({ colorVariant, theme }) => (colorVariant ? theme.typography.colors[colorVariant].bullets : '')};
      }
    }
  }

  a {
    ${({ colorVariant }) => (colorVariant ? ((colorVariant === 'light') ? lightLinkStyles : darkLinkStyles) : '')};
  }
`;

export default Paragraph;
